import React, { FunctionComponent } from 'react'

type DirectoryFileIconProps = {
  color?: string
  className?: string
}

const DirectoryFileIcon: FunctionComponent<DirectoryFileIconProps> = ({
  className = '',
  color = '#384A51',
}: DirectoryFileIconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        d="M11.2917 4.78732C11.2843 4.76598 11.2783 4.74532 11.2697 4.72465C11.237 4.65399 11.1963 4.58665 11.139 4.52932L7.13899 0.529318C7.08166 0.471984 7.01433 0.431318 6.94366 0.398651C6.92366 0.389318 6.90233 0.383984 6.88099 0.376651C6.82499 0.357984 6.76766 0.345984 6.70833 0.342651C6.69366 0.341318 6.68099 0.333984 6.66699 0.333984H2.00033C1.26499 0.333984 0.666992 0.931984 0.666992 1.66732V12.334C0.666992 13.0693 1.26499 13.6673 2.00033 13.6673H10.0003C10.7357 13.6673 11.3337 13.0693 11.3337 12.334V5.00065C11.3337 4.98665 11.3263 4.97398 11.325 4.95932C11.3217 4.90065 11.3103 4.84332 11.2917 4.78732ZM9.05766 4.33398H7.33366V2.60998L9.05766 4.33398ZM2.00033 12.334V1.66732H6.00033V5.00065C6.00033 5.36932 6.29833 5.66732 6.66699 5.66732H10.0003L10.0017 12.334H2.00033Z"
        fill={color}
      />
    </svg>
  )
}

export default DirectoryFileIcon
